import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { history } from './utils/history';

import SwitchRouter from './router/SwitchRouter';
import { getLanguage } from './utils/params';

const App = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const cityId = params.get('cityId');

    if (cityId === 'hanoi') {
      localStorage.setItem('LOCATION_CITY', 'dc41a87d-ba30-aa3b-ecb2-5f1baf128ecd');
    } else if (cityId === 'hcm') {
      localStorage.setItem('LOCATION_CITY', '3613eeb3-a88c-b394-ea44-5f1d4ff844c5');
    } else if (cityId === 'danang') {
      localStorage.setItem('LOCATION_CITY', '37a7b0d7-6fce-df8b-f54a-6604f7a89588');
    } else if (cityId === 'haiphong') {
      localStorage.setItem('LOCATION_CITY', '64aed160-8cfb-a33f-e9a3-5f1d4f652e6f');
    }
    const setLanguage = async data => {
      if (data) {
        if (data === 'ja' && !location.pathname.startsWith('/jp')) {
          if (location.pathname.startsWith('/en')) {
            history.push(location.pathname.replace('/en', '/jp') + location.search);
          } else {
            history.push(`/jp${location.pathname}${location.search}`);
          }
        } else if (data === 'en') {
          if (!location.pathname.startsWith('/en')) {
            if (location.pathname.startsWith('/jp')) {
              history.push(location.pathname.replace('/jp', '/en') + location.search);
            }
          }
        }

        await i18n.changeLanguage(data === 'ja' ? 'jp' : 'en');
        await localStorage.setItem('language', data === 'ja' ? 'jp' : 'en');
      }
    };

    let language = '';
    const languageLocaleStorage = localStorage.getItem('language');
    const getLanguageBrowser =
      navigator.userLanguage || navigator.language || window.navigator.userLanguage || window.navigator.language;
    if (location.pathname.startsWith('/jp') || location.pathname.startsWith('/en')) {
      if (location.pathname.startsWith('/jp')) language = 'ja';
      else if (location.pathname.startsWith('/en')) language = 'en';
    } else if (languageLocaleStorage) {
      if (languageLocaleStorage === 'jp') language = 'ja';
      else language = 'en';
    } else if (getLanguageBrowser) {
      if (getLanguageBrowser === 'ja' || getLanguageBrowser.toLowerCase() === 'ja-jp') language = 'ja';
      else language = 'en';
    } else language = getLanguage(location);

    setLanguage(language);
  }, [i18n, location]);

  return <SwitchRouter />;
};

export default App;
